import { Container } from "@/shared/components/Container";
import { SectionTag } from "@/shared/components/SectionTag";
import { GradientHeading } from "@/shared/components/GradientHeading";
import { MetricCard } from "@/shared/components/MetricCard";
import { Reveal } from "@/shared/components/Reveal";
import { useInView } from "@/shared/hooks/useInView";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import styles from "./Results.module.css";

const METRIC_CLASSES = [styles.cardMoney, styles.cardCountries, styles.cardPeople];

export function Results() {
  const locale = useLocale();
  const content = getHomeContent(locale);

  // O palco coordena apenas o globo; os cards entram individualmente.
  const { ref: stageRef, inView } = useInView<HTMLDivElement>({
    enterEdgeRatio: 0.1,
    once: true,
  });

  return (
    <section id="resultados" className={styles.results}>
      <Container>
        <div className={styles.header}>
          <Reveal>
            <SectionTag>{content.results.tag}</SectionTag>
          </Reveal>
          <Reveal delay={80} className={styles.titleReveal}>
            <GradientHeading className={styles.title}>
              {content.results.title}
            </GradientHeading>
          </Reveal>
          <Reveal as="p" className={styles.subtitle} delay={140}>
            {content.results.subtitle}
          </Reveal>
        </div>

        <div
          ref={stageRef}
          className={`${styles.stage} ${inView ? styles.stageIn : ""}`}
        >
          <img
            className={styles.globe}
            src="/assets/globo-wireframe.svg"
            alt=""
            aria-hidden
            loading="eager"
            decoding="async"
          />
          {/* Pontos laranja do protótipo (9×9) nos cruzamentos do wireframe. */}
          <span className={`${styles.dot} ${styles.dotTop}`} aria-hidden />
          <span className={`${styles.dot} ${styles.dotRight}`} aria-hidden />
          <span className={`${styles.dot} ${styles.dotBottomLeft}`} aria-hidden />
          {content.results.metrics.map((metric, index) => (
            <Reveal
              key={metric.label}
              className={`${styles.metricReveal} ${METRIC_CLASSES[index] ?? ""}`}
              delay={index * 90}
            >
              <MetricCard
                icon={metric.icon}
                label={metric.label}
                prefix={metric.prefix}
                value={metric.value}
              />
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
